export var stopEvent = function (event) {
    if (!event) {
        return;
    }
    event.preventDefault();
    event.stopPropagation();
};
//# sourceMappingURL=stopEvent.js.map